import ProveedorStepper from "../components/Stepper/ProveedorStepper";

export default function AddProveedorPage() {
  return <ProveedorStepper />;
}
